module.exports = __webpack_public_path__ + "img/operationCapacity6.a2f4c6bd.png";